<div class="wrapper">
    <app-navigation></app-navigation>
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <section class="content-header">
            <div class="row">
                <div class="col-md-8">
                    <div class="tab-heading">
                        <span class="tab-heading-title">RMS Simulator</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="right-section">
                        <button class="custombtn" (click)="startNewCheckout()">New Checkout</button>
                    </div>
                </div>
            </div>
        </section>

        <section class="add-section">
            <div class="row pb-3">
                <div class="col-md-12 section-heading">Wholesaler Authentication</div>
            </div>
            <form [formGroup]="authForm">
                <div class="row pb-3">
                    <div class="col-md-6">
                        <label class="form-label">RMS-X-AUTH-KEY</label>
                        <input
                            class="form-input"
                            type="text"
                            placeholder="Paste the wholesaler's RMS API key"
                            formControlName="rmsAuthKey" />
                        <div class="rms-hint">
                            Issued/rotated on the wholesaler's admin page - never checked in or
                            hardcoded here, only remembered in this browser.
                        </div>
                    </div>
                </div>
            </form>
        </section>

        <section class="add-section">
            <div class="row pb-3">
                <div class="col-md-12 section-heading">
                    Step 1 - Identify Customer (POST /user/identify)
                </div>
            </div>
            <form [formGroup]="identifyForm">
                <div class="row pb-3">
                    <div class="col-md-3">
                        <!-- LP-5200: transport-neutral, so not labelled "QR" - the same field
                             carries a scanned QR, another supported scanner's output, or a
                             manually typed credential. -->
                        <label class="form-label">Code</label>
                        <input class="form-input" type="text" formControlName="code" />
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Mobile Number</label>
                        <input class="form-input" type="text" formControlName="mobileNumber" />
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Request ID</label>
                        <input class="form-input" type="text" formControlName="requestId" />
                    </div>
                    <div class="col-md-3 rms-step-action">
                        <button
                            class="custombtn"
                            type="button"
                            [disabled]="authForm.invalid || submittingStep === 'identify'"
                            (click)="submitIdentify()">
                            {{ submittingStep === 'identify' ? 'Identifying...' : 'Identify' }}
                        </button>
                    </div>
                </div>
                <div class="row pb-3">
                    <div class="col-md-12 rms-hint">
                        Supply exactly one of Code or Mobile Number. Request ID is the idempotency
                        key for the Mobile Number path and is required there - reusing one replays
                        that identify's original outcome instead of running a new one. It is
                        ignored when a Code is supplied.
                    </div>
                </div>
                <div class="row" *ngIf="identifyToken">
                    <div class="col-md-12">
                        <span class="rms-result-ok">status: {{ identifyStatus }}</span>
                        &nbsp;&mdash;&nbsp;
                        <!-- LP-5197: cashier display/visual-confirmation only - the till's own
                             identity/session authority for Checkout is the token below, not this. -->
                        <strong>{{ identifyTraderDisplayName }}</strong>
                        (Mobile: {{ identifyTraderMobileMasked }})
                    </div>
                    <div class="col-md-12">
                        <span class="rms-result-ok">Token:</span>
                        <code class="rms-token-value">{{ identifyToken }}</code>
                        (expires at {{ identifyExpiresAt }})
                        <span *ngIf="resetTokenExpiryWarning()" class="rms-result-error">
                            already expired - re-identify before checking out
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="identifyError">
                    <div class="col-md-12 rms-result-error">{{ identifyError }}</div>
                </div>
            </form>
        </section>

        <section class="add-section">
            <div class="row pb-3">
                <div class="col-md-12 section-heading">Step 2 - Checkout (POST /checkout)</div>
            </div>
            <form [formGroup]="checkoutForm">
                <div class="row pb-3">
                    <div class="col-md-4">
                        <label class="form-label">Request ID</label>
                        <input class="form-input" type="text" formControlName="requestId" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Token</label>
                        <input class="form-input" type="text" formControlName="token" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Checkout Till ID</label>
                        <input class="form-input" type="text" formControlName="checkoutTillId" />
                    </div>
                </div>

                <div class="row pb-3" *ngIf="demoProducts.length">
                    <div class="col-md-12 rms-hint">Quick Add (this environment's demo products)</div>
                    <div class="col-md-12 rms-quickadd-list">
                        <button
                            class="custombtn rms-secondary-btn rms-quickadd-btn"
                            type="button"
                            *ngFor="let product of demoProducts"
                            (click)="addDemoProduct(product)">
                            {{ product.name }} &mdash; R{{ product.sellingPrice.toFixed(2) }}
                        </button>
                    </div>
                </div>
                <div class="row pb-3" *ngIf="!demoProducts.length">
                    <div class="col-md-12 rms-hint">
                        No demo products configured for this environment - add some to
                        environment.rmsSimulatorDemoProducts to get one-click cart rows here.
                    </div>
                </div>

                <div formArrayName="cart">
                    <div class="row" *ngFor="let item of cart.controls; let i = index">
                        <div [formGroupName]="i" class="row rms-cart-row-inner">
                            <div class="col-md-2">
                                <label class="form-label">Supplier Code</label>
                                <input class="form-input" type="text" formControlName="supplierCode" />
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">Product Code</label>
                                <input class="form-input" type="text" formControlName="productCode" />
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">Barcode</label>
                                <input class="form-input" type="text" formControlName="barcode" />
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">Quantity</label>
                                <input class="form-input" type="number" min="1" formControlName="quantity" />
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">Selling Price</label>
                                <input
                                    class="form-input"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    formControlName="sellingPrice" />
                            </div>
                            <div class="col-md-2 rms-cart-row-remove">
                                <button
                                    class="custombtn rms-secondary-btn"
                                    type="button"
                                    [disabled]="cart.length <= 1"
                                    (click)="removeCartItem(i)">
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row pb-3">
                    <div class="col-md-4">
                        <button class="custombtn rms-secondary-btn" type="button" (click)="addCartItem()">
                            + Add Line
                        </button>
                    </div>
                    <div class="col-md-4 rms-basket-total">Basket Total: R {{ basketTotal.toFixed(2) }}</div>
                    <div class="col-md-4 rms-step-action">
                        <button
                            class="custombtn"
                            type="button"
                            [disabled]="checkoutForm.invalid || authForm.invalid || submittingStep === 'checkout'"
                            (click)="submitCheckout()">
                            {{ submittingStep === 'checkout' ? 'Checking out...' : 'Checkout' }}
                        </button>
                    </div>
                </div>

                <div class="row" *ngIf="checkoutId">
                    <div class="col-md-12">
                        <span class="rms-result-ok">checkoutId: {{ checkoutId }}</span>
                        &nbsp;status: {{ checkoutStatus }}
                        &nbsp;redemptionAmount: {{ redemptionAmount }}
                        &nbsp;authCode: <code class="rms-token-value">{{ checkoutAuthCode }}</code>
                    </div>
                    <div class="col-md-12 rms-hint">
                        authCode is now a checkout-scoped confirmation credential (LP-5198) - it is
                        carried into Step 3 automatically; a real till must store it with the open
                        sale and never display it to the cashier.
                    </div>
                </div>
                <div class="row" *ngIf="checkoutError">
                    <div class="col-md-12 rms-result-error">{{ checkoutError }}</div>
                </div>
            </form>
        </section>

        <section class="add-section">
            <div class="row pb-3">
                <div class="col-md-12 section-heading">
                    Step 3 - Confirm Sale (POST /sales/confirm)
                </div>
            </div>
            <form [formGroup]="confirmForm">
                <div class="row pb-3">
                    <div class="col-md-4">
                        <label class="form-label">Sale Reference</label>
                        <input class="form-input" type="text" formControlName="saleReference" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Checkout ID</label>
                        <input class="form-input" type="text" formControlName="checkoutId" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Auth Code</label>
                        <input class="form-input" type="text" formControlName="authCode" />
                        <div class="rms-hint">
                            auto = Checkout's own authCode - edit to test a
                            missing/wrong-credential rejection
                        </div>
                    </div>
                </div>
                <div class="row pb-3">
                    <div class="col-md-4">
                        <label class="form-label">Confirmation Till ID</label>
                        <input class="form-input" type="text" formControlName="saleConfirmationTillId" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Completed At</label>
                        <input class="form-input" type="text" formControlName="completedAt" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Final Total</label>
                        <input class="form-input" type="number" step="0.01" formControlName="finalTotal" />
                        <div class="rms-hint">auto = basket total &minus; redemption amount</div>
                    </div>
                </div>
                <div class="row pb-3">
                    <div class="col-md-4 rms-step-action">
                        <button
                            class="custombtn"
                            type="button"
                            [disabled]="confirmForm.invalid || authForm.invalid || submittingStep === 'confirm'"
                            (click)="submitConfirmSale()">
                            {{ submittingStep === 'confirm' ? 'Confirming...' : 'Confirm Sale' }}
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="confirmStatus">
                    <div class="col-md-12">
                        <span class="rms-result-ok">status: {{ confirmStatus }}</span>
                        <span *ngIf="confirmErrors" class="rms-result-error">
                            &nbsp;{{ confirmErrors.join('; ') }}
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="confirmError">
                    <div class="col-md-12 rms-result-error">{{ confirmError }}</div>
                </div>
            </form>
        </section>

        <section class="add-section">
            <div class="row pb-3">
                <div class="col-md-8 section-heading">Request / Response Log</div>
                <div class="col-md-4 rms-step-action">
                    <button class="custombtn rms-secondary-btn" type="button" (click)="clearLogs()">
                        Clear Log
                    </button>
                </div>
            </div>
            <div class="rms-log-panel">
                <div class="rms-log-entry" *ngFor="let entry of logs">
                    <div class="rms-log-heading">
                        <span class="rms-log-time">{{ entry.time }}</span>
                        <span class="rms-log-label">{{ entry.label }}</span>
                        <span *ngIf="entry.error" class="rms-result-error">FAILED</span>
                        <span *ngIf="!entry.error" class="rms-result-ok">OK</span>
                    </div>
                    <div class="rms-log-body">
                        <div>
                            <div class="rms-log-section-title">Request</div>
                            <pre>{{ entry.request | json }}</pre>
                        </div>
                        <div>
                            <div class="rms-log-section-title">{{ entry.error ? 'Error' : 'Response' }}</div>
                            <pre>{{ (entry.error || entry.response) | json }}</pre>
                        </div>
                    </div>
                </div>
                <div class="rms-log-empty" *ngIf="logs.length === 0">No calls made yet.</div>
            </div>
        </section>
    </div>
</div>
